import vText from './Text.vue';

export {
    vText,
};



// WEBPACK FOOTER //
// ./src/baseComponents/components/Typography/index.js